import React, {Fragment, useContext} from "react";
import {Button, Card, Divider, Form, Row, Switch, Tabs, Upload} from "antd";
import {API_BASE_URL, ASSET_BASE_URL} from "../../configs/AppConfig";
import {InboxOutlined, FileImageOutlined, DeleteOutlined} from "@ant-design/icons";
import {useSelector} from "react-redux";
import {LANGS} from "../../lang";
import {getDeviseSymbol, getLanguage} from "../permissions/functions";
import MultiAssocForm from "./MultiAssocForm";
import MultiAssocForm2 from "./MultiAssocForm2";
import SeoPanelFields from "./SeoPanelFields";


function formatFormChildren(children, devise) {
    let _children = [];

    React.Children.forEach(children, (child) => {

        if (React.isValidElement(child)) {
            const _props = {...child.props}
            let addToChildren=false

            switch (child.type) {
                case Form.Item:
                    if(_props.__deviseSupport)
                    {
                        addToChildren=true
                        _props.key = devise + "." + _props.name
                        _props.name = [devise, _props.name]
                        if (_props.label) {
                            _props.label = _props.label + " - (" + getDeviseSymbol(devise) + ")"
                        }

                        if (_props.rules) {
                            _props.rules = _props.rules.filter(i => !i.required)
                        }
                    }
                    break;
                case MultiAssocForm:
                case MultiAssocForm2:
                    addToChildren=true
                    _props.__deviseSupport = true
                    _props.devise = devise
                    break;
                default:
                    if (_props.children) {
                        _props.children = formatFormChildren(_props.children, devise)
                        if(React.Children.toArray(_props.children).length>0){
                            addToChildren=true
                        }
                    }
            }

            if(addToChildren){
                _children.push(React.cloneElement(child, _props))
            }
        }

        return child
    })

    return _children
}




function getChildren(children) {
    let _children = []
    React.Children.forEach(children, (child) => {

        if (React.isValidElement(child)) {
            const _props = {...child.props}

            if (child.props?.__deviseSupport || [MultiAssocForm,MultiAssocForm2].includes(child.type)) {
                _children.push(child)
            }

        }
    })

    return _children
}

export class ActiveDevise extends React.Component{

    render()
    {
        const props=this.props

        return(
            <Form.Item label={"Désactiver la proposition automatique"} name={[props.devise,"__disabledChangeDevise"]} valuePropName={"checked"}>
                <Switch/>
            </Form.Item>
        )
    }
}

const MultiDevise = (props) => {

    let devises = useSelector(state => state.auth.org.devises)
    let defaultDevise = useSelector(state => state.auth.org.devise) || "eur"

    //console.log("forceDevise",props.forceDevise)
    if(props.forceDevise){
        defaultDevise=props.forceDevise
        devises=[defaultDevise]
    }

    let functionalMainChildren=false
    let mainChildren = props.children
    if (typeof mainChildren === "function") {
        functionalMainChildren=true
        mainChildren = props.children(defaultDevise)
    }

    if (devises.length === 1 || props.disabled) {
        return mainChildren
    }


    let tabs = []

    if(functionalMainChildren){
        tabs = [{key: "default", label: defaultDevise?.toUpperCase()+" "+getDeviseSymbol(defaultDevise), children: mainChildren}]
    }

    for (var d of devises.slice(1)) {

        let children = null

        if (typeof props.children === "function") {
            children = props.children(d)
        } else {
            children = formatFormChildren(props.children, d)
        }

        tabs.push({key: d, label: d?.toUpperCase()+" "+getDeviseSymbol(d), children: (
            <Fragment>
                {!functionalMainChildren &&(
                    <ActiveDevise devise={d}/>
                )}

                {children}
            </Fragment>
        )})
    }


    if(functionalMainChildren){
        return (
            <Tabs tabBarStyle={{marginTop: 0}} items={tabs}/>
        )
    }

    return (
        <Fragment>
            {mainChildren}

            <Divider>Multi Devise</Divider>
            <Tabs position={"left"} tabBarStyle={{marginTop: 0}} items={tabs}/>
        </Fragment>
    )
}


export default MultiDevise
